import Vue from "vue";
import sourceDic from "../helper/sourceDic";
Vue.filter("json", function (value) {
    var result = "";
    try {
        result = JSON.stringify(value);
    }
    catch (e) {
        console.error(e.message);
    }
    return result;
});
Vue.filter("thousand", function (value) {
    if (!value) {
        return "0w";
    }
    var num = Number(value) / 10000;
    var int = parseInt(num.toString());
    var float = num - int;
    var w = int.toString().split("").reverse();
    var arr = [];
    while (w.length) {
        arr.push(w.splice(0, 3).reverse().join(""));
    }
    var str = arr.reverse().join("");
    if (float) {
        str = str + float.toFixedNoZero(3).substr(1, 3);
    }
    return str + "w";
});
Vue.filter("statearrow", function (value) {
    return value == 1 ? "<span style='color:#FE7437;'>↑</span>" : "<span style='color:#29CB97;'>↓</span>";
});
Vue.filter("clientSource", function (value) {
    return sourceDic[value];
});
